import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  baseTrackingSchema,
  exampleBaseTrackingSchemaInstance,
} from "./base-tracking";

export const orderTrackingSchema = defineSchema({
  fields: {
    ...baseTrackingSchema.fields,
    cancelReason: {
      dataType: "Maybe Text",
      documentation:
        "Why the order was cancelled: customer, fraud, inventory, declined, staff or other. Empty if the order was not cancelled.",
    },
    cancelledBy: {
      dataType: "Maybe Text",
      documentation:
        "Who cancelled the order: customer, merchant (inventory or staff reasons) or unknown. Empty if the order was not cancelled.",
    },
    cancelLevel: {
      dataType: "Maybe Text",
      documentation:
        "Whether a shipment cancelled event is for the whole order (order) or for a single shipment (shipment). Only set on shipment cancelled events.",
    },
  },
});

export const exampleOrderTrackingSchemaInstance: SchemaInstance<
  typeof orderTrackingSchema
> = {
  ...exampleBaseTrackingSchemaInstance,
  cancelReason: "customer",
  cancelledBy: "customer",
  cancelLevel: "order",
};

// const defaultTracker: TrackerDataType = {
//   Code: "1234567890",
//   Carrier: "USPS",
//   Status: "delivered" as ExternalShipmentTracker['status'],
//   DeliveryEstimate: new Date(
//     Temporal.Now.instant().add({ hours: weekInHours }).toString(),
//   ),
//   RoughDeliveryEstimate: new Date(
//     Temporal.Now.instant().add({ hours: weekInHours }).toString(),
//   ),
//   Details: [
//     {
//       Message: "Order received",
//       Status: "pre_transit" as ExternalShipmentTracker['status'],
//       Datetime: new Date(),
//     },
//   ],
//   Link: "https://example.com",
// };
